import { InferType, object, string } from 'yup';

export const personalInfoValidationSchema = object().shape({
  name: string()
    .required('Name is required')
    .min(3, 'Name must be at least 3 characters long'),
  email: string()
    .email('Email must be a valid email')
    .required('Email is required'),
});

export type PersonalInfoFormFields = InferType<
  typeof personalInfoValidationSchema
>;
